import { makeStyles } from '@mui/styles';
import { styles } from '@tcs/create-account/utils/theme';

export const useStyles = makeStyles({
  wrapper: {
    minHeight: 450,
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    alignItems: 'center',
    justifyContent: 'center',
    [styles.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gridTemplateRows: '1fr 1fr',
    },
  },
  left: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    background: 'linear-gradient(160deg, #2c404f -20%, #7e98a8 140%)',
    [styles.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  leftContent: {
    maxWidth: 500,
    [styles.breakpoints.up('sm')]: {
      marginRight: 48,
    },
    [styles.breakpoints.down('sm')]: {
      margin: 24,
    },
  },
  code: {
    fontSize: 128,
    textAlign: 'center',
    color: styles.palette.text.inverse,
    fontWeight: 200,
    transition: styles.transitions.regular(['font-size']),
    [styles.breakpoints.down('sm')]: {
      fontSize: 80,
    },
  },
  message: {
    color: styles.palette.text.inverse,
    fontWeight: 300,
  },
  right: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    [styles.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  rightContent: {
    maxWidth: 500,
    margin: '0 24px 0 48px',
    [styles.breakpoints.up('sm')]: {
      marginTop: 48,
    },
    [styles.breakpoints.down('sm')]: {
      margin: 24,
    },
  },
  description: {
    marginBottom: 32,
    fontSize: 28,
    fontWeight: 300,
    lineHeight: 1.2,
    transition: styles.transitions.regular(['font-size']),
    [styles.breakpoints.down('sm')]: {
      textAlign: 'center',
      fontSize: 24,
    },
  },
});
